import { useQuery } from '@tanstack/react-query';
import { API_AGGREGATOR_GET_STATUS } from 'src/api/aggregator-request-objects';
import { TsQueryI } from 'src/api/query-logic/query-interfaces';
import { createQueryKey } from 'src/api/query-logic/query-utils';
import { apiRequest } from 'src/api/request-handler';
import { AggregatorStatusResponse } from 'src/interfaces/aggregator.interfaces';

export const queryAggregatorStatus = (obj: TsQueryI) => {
  return useQuery<AggregatorStatusResponse>({
    queryKey: createQueryKey('aggregator-status', obj.queryKey),
    queryFn: async () => {
      const res = await apiRequest<AggregatorStatusResponse>(API_AGGREGATOR_GET_STATUS, obj.reqData);
      return res;
    },
    staleTime: 0,
    ...obj.queryOpt,
    refetchOnWindowFocus: false,
  });
};
